import getFirebaseAuth from 'actions/firebase/auth'
import { signInWithCustomToken } from 'firebase/auth'

const customerLogin = async (token) => signInWithCustomToken(getFirebaseAuth(), token)

export default customerLogin
